export { ListItemIcon } from './ListItemIcon';
export type { ListItemIconProps } from './ListItemIcon';
